import React, { useState, useEffect, useRef } from 'react';

const LogosSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const allLogos = [
    { src: 'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/kapilIT.png?updatedAt=1750758215731', alt: 'Kapil IT', label: 'Kapil IT Solutions' },
    { src: 'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/KCS%20TECH_logo.png?updatedAt=1750758410764', alt: 'KCS TECH', label: 'KCS Tech' },
    { src: 'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/kapilitSkillHub.jpg?updatedAt=1750758215735', alt: 'Kapil IT Skill Hub', label: 'Skill Hub' },
    { src: 'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/Nasscom.png?updatedAt=1750758215847', alt: 'NASSCOM Certified', label: 'NASSCOM' },
    { src: 'https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/iso2.png?updatedAt=1750758215744', alt: 'ISO Certified', label: 'ISO 9001:2015' },
    { src: "https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/Picture2.png?updatedAt=1750758216406", alt: "ISO Certified", label: 'ISO 27001' },
    { src: "https://ik.imagekit.io/kqumni8l2/Comoany%20Certificate%20Logoes/cmmi3.png?updatedAt=1750765075210", alt: "CMMI Level 3 Certified", label: 'CMMI Level 3' }
  ];

  // Split logos into two rows: 4 on top, 3 on bottom (offset)
  const firstRow = allLogos.slice(0, 4);
  const secondRow = allLogos.slice(4);

  const renderCard = (logo, idx) => (
    <div key={idx} className="group relative flex-1 min-w-0">
      {/* Card with white background */}
      <div
        className="relative overflow-hidden flex items-center justify-center"
        style={{
          backgroundColor: '#ffffff',
          height: '110px',
          border: '1px solid rgba(229, 231, 235, 0.8)',
          boxShadow: '0 4px 15px -5px rgba(0, 0, 0, 0.15)'
        }}
      >
        {/* Logo image */}
        <img
          src={logo.src}
          alt={logo.alt}
          className="max-w-[120px] max-h-[60px] w-auto h-auto object-contain relative z-10"
        />
      </div>
    </div>
  );

  return (
    <section
      ref={sectionRef}
      className="relative py-24 overflow-hidden"
      style={{ backgroundColor: '#001534' }}
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-5 leading-tight text-white">
            Our Ecosystem & Certifications
          </h1>
        </div>

        {/* Staggered Layout - Row 2 items sit between Row 1 items */}
        <div className="max-w-5xl mx-auto">
          {/* First Row: 4 logos */}
          <div className="flex gap-5 md:gap-6">
            {firstRow.map((logo, idx) => renderCard(logo, idx))}
          </div>

          {/* Second Row: 3 logos, offset to sit between first row items */}
          {/* Offset = half a column width + half a gap */}
          {/* Column width = (100% - 3*gap) / 4, so half column = (100% - 3*gap) / 8 */}
          <div
            className="flex gap-5 md:gap-6 mt-5 md:mt-10"
            style={{
              paddingLeft: 'calc((100% - 3 * 24px) / 8 + 12px)',
              paddingRight: 'calc((100% - 3 * 24px) / 8 + 12px)'
            }}
          >
            {secondRow.map((logo, idx) => renderCard(logo, idx + 4))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogosSection;
